











































import { Component, PropSync, Prop, Vue, Watch } from "vue-property-decorator";
import { ReservationAccUnitModel } from "./types";

@Component
export default class UnitSelectionModal extends Vue {
  @Prop() title?: string;
  @PropSync("open", { default: false }) internalOpen?: boolean;
  @Prop({ default: () => [] }) units?: ReservationAccUnitModel[];
  @Prop() action?: (ids: number[]) => void;

  selectedIds = [] as number[];
  @Watch("internalOpen")
  openWatch(fresh: boolean) {
    if (fresh) {
      this.selectedIds = [];
    }
  }

  accept() {
    this.internalOpen = false;
    if (this.action) this.action(this.selectedIds);
  }

  get isAllSelected(){
    return this.units?.length === this.selectedIds.length;
  }

  selectAllUnits() {
    if(this.isAllSelected){
      this.selectedIds = [];
    }
    else{
      this.units?.forEach(unit => {
        this.selectedIds.push(unit.id);
      })
    }
  }
}
